import { render, staticRenderFns } from "./SocialMarketingStudioInfo.vue?vue&type=template&id=3c940683&scoped=true&"
import script from "./SocialMarketingStudioInfo.vue?vue&type=script&lang=js&"
export * from "./SocialMarketingStudioInfo.vue?vue&type=script&lang=js&"
import style0 from "./SocialMarketingStudioInfo.vue?vue&type=style&index=0&id=3c940683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c940683",
  null
  
)

export default component.exports